import ModalFailure from "../../common/modal-failure/modal-failure.component";

const RegistrationFailure = () => {
  const title = "Registrierung nicht möglich";
  const description = "Die Registrierung konnte nicht abgeschlossen werden";
  return <ModalFailure title={title} description={description} />;
};

export default RegistrationFailure;
